import * as React from "react";
import i18n from "../../i18n/i18n";
import * as classNames from "classnames";
import * as PropTypes from "prop-types";
import IErrorVm from "../../models/home/Error/IErrorVm";

const InputMask = require("react-input-mask"); // Need to import it the js way

export enum InputType {
  Date,
  Text,
  Numbers,
}

interface ITextFieldProps {
  value: string;
  label: string;
  readonly?: boolean;
  className?: string;
  mask?: string;
  maskChar?: string;
  placeholder?: string;
  errorProperty?: string;
  submitButton?: JSX.Element;
  type?: InputType;
  spanType?: string;
  uiTestAttribute?: string;
  customError?: string;
  onChange?: (value: any) => void;
  onEnter?: () => void;
}

export default class TextField extends React.Component<ITextFieldProps> {
  public context: { errors: IErrorVm[] };

  public static defaultProps: Partial<ITextFieldProps> = {
    readonly: false,
  };

  public static contextTypes: React.ValidationMap<any> = {
    errors: PropTypes.array,
  };

  private onEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.which === 13 || e.keyCode === 13 || e.key === "Enter") {
      this.props.onEnter();
    }
  }

  private getTextField() {
    const { readonly, value, label, onChange, mask, maskChar, placeholder, submitButton, type, uiTestAttribute } = this.props;

    if (readonly) {
      const classes = classNames({
        "input-block-level": !submitButton,
      });

      return (
        <input
          onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
            this.onEnter(e);
          }}
          className={classes}
          id={label}
          type="text"
          value={value || ""}
          data-ui-test={uiTestAttribute || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          disabled={true}
        />
      );
    } else {
      let inputElement: JSX.Element;

      const classes = classNames({
        "input-block-level": !submitButton,
      });

      if (type === InputType.Date) {
        inputElement = (
          <InputMask
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
              this.onEnter(e);
            }}
            id={label}
            className={classes}
            value={value || ""}
            data-ui-test={uiTestAttribute || ""}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            mask="99-99-9999"
            maskChar={" "}
            type="text"
          />
        );
      } else if (type === InputType.Numbers) {
        inputElement = (
          <input
            onKeyPress={(e) => {
              this.onEnter(e);
            }}
            id={label}
            className={classes}
            value={value || ""}
            data-ui-test={uiTestAttribute || ""}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const re = /^[0-9\b]+$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                onChange(e.target.value);
              }
            }}
            type="text"
          />
        );
      } else if (mask) {
        inputElement = (
          <InputMask
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
              this.onEnter(e);
            }}
            mask={mask}
            maskChar={maskChar}
            placeholder={placeholder || " "}
            className={classes}
            id={label}
            type="text"
            value={value || ""}
            data-ui-test={uiTestAttribute || ""}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          />
        );
      } else {
        inputElement = (
          <input
            onKeyPress={(e) => {
              this.onEnter(e);
            }}
            className={classes}
            id={label}
            type="text"
            value={value || ""}
            data-ui-test={uiTestAttribute || ""}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          />
        );
      }

      return !submitButton ? (
        inputElement
      ) : (
        <div className="input-append" style={{ marginBottom: "0px" }}>
          {inputElement}
          <span className="input-group-btn">{submitButton}</span>
        </div>
      );
    }
  }

  public render() {
    const { readonly, label, className, spanType, errorProperty, customError, type } = this.props;

    const errors = (this.context.errors || []).filter((x: IErrorVm) => {
      return !readonly && x.property === errorProperty;
    });

    const labelClasses = classNames({
      required: errorProperty && !readonly,
    });

    const textField = this.getTextField();

    return (
      <div className={`datafield ${spanType} ${className}`}>
        <label htmlFor={label} className={labelClasses}>
          {i18n.t(label)}
          {type === InputType.Date && <span className="accessibility"> i format dag måned år</span>}
        </label>
        {textField}
        {errors.map((err, i) => {
          return (
            <p key={i} className="alert alert-warning">
              {err.message}
            </p>
          );
        })}
        {!!customError && <p className="alert alert-warning">{i18n.t(customError)}</p>}
      </div>
    );
  }
}
